import { createFileRoute, Navigate } from '@tanstack/react-router'

import { useAuthIsAuthenticated } from '@/entities/auth'

export const Route = createFileRoute('/')({
    component: App,
})

function App() {
    const { isAuthenticated } = useAuthIsAuthenticated()

    if (isAuthenticated) {
        return <Navigate to='/appointments' />
    }

    return <Navigate to='/login' />
}
